export default "__VITE_ASSET__WaHp9xx4__"